<template>
  <div class="dynamics-withdraw-modal">
    <div class="withdraw-modal-body">
      <Form ref="withdrawForm" :model="withdrawForm" inline>
        <div class="withdraw-section-header">
          <span style="color:#ed4014">*</span>Withdrawal Information
        </div>
        <div style="padding: 0 16px">
          <FormItem
            required
            v-for="item in [
                {key: 'withdraw_amount', label: 'Amount', width: 200 },
                {key: 'withdraw_name', label: 'Beneficiary Name', width: 200 },
                {key: 'withdraw_country', label: 'Beneficiary Country', width: 200 },
                {key: 'withdraw_city', label: 'Beneficiary City', width: 200 },
                {key: 'withdraw_address', label: 'Beneficiary Address', width: 420 },
                {key: 'withdraw_zip', label: 'Beneficiary Zip/Postal', width: 200 },
                {key: 'withdraw_telephone', label: 'Beneficiary Telephone', width: 200 },
            ]"
            :prop="item.key"
            :key="item.key"
            :label="item.label"
            :show-message="false"
          >
            <i-input
              v-model="withdrawForm[item.key]"
              :placeholder="item.label"
              :style="`width: ${item.width}px`"
            />
          </FormItem>
        </div>
        <Collapse simple>
          <Panel>
            <div class="withdraw-section-header">Intermediary Bank Information (Optional)</div>
            <template slot="content">
              <FormItem
                v-for="item in [
                    {key: 'inter_bank_name', label: 'Bank Name', width: 200 },
                    {key: 'inter_bank_code', label: 'Bank SWIFT Code', width: 200 },
                    {key: 'inter_bank_country', label: 'Bank Country', width: 200 },
                    {key: 'inter_bank_city', label: 'Bank City', width: 200 },
                    {key: 'inter_bank_address', label: 'Bank Address', width: 420 },
                    {key: 'inter_bank_zip', label: 'Bank Zip/Postal', width: 200 },
                    {key: 'inter_bank_account', label: 'Account Number/IBAN', width: 200 },
                    {key: 'inter_bank_routing', label: 'Routing/Transit Number', width: 420 },
                    {key: 'inter_bank_credit', label: 'For credit to', width: 420 },
                  ]"
                :prop="item.key"
                :key="item.key"
                :label="item.label"
              >
                <i-input
                  v-model="withdrawForm[item.key]"
                  :placeholder="item.label"
                  :style="`width: ${item.width}px`"
                />
              </FormItem>
            </template>
          </Panel>
        </Collapse>
        <div class="withdraw-section-header">
          <span style="color:#ed4014">*</span>Beneficiary Bank Information
        </div>
        <div style="padding: 0 16px">
          <FormItem
            required
            v-for="item in [
                {key: 'bank_name', label: 'Bank Name', width: 200 },
                {key: 'bank_code', label: 'Bank SWIFT Code', width: 200 },
                {key: 'bank_country', label: 'Bank Country', width: 200 },
                {key: 'bank_city', label: 'Bank City', width: 200 },
                {key: 'bank_address', label: 'Bank Address', width: 420 },
                {key: 'bank_zip', label: 'Bank Zip/Postal', width: 200 },
                {key: 'bank_account', label: 'Account Number/IBAN', width: 200 },
                {key: 'bank_routing', label: 'Routing/Transit Number', width: 420 },
            ]"
            :prop="item.key"
            :key="item.key"
            :label="item.label"
            :show-message="false"
          >
            <i-input
              v-model="withdrawForm[item.key]"
              :placeholder="item.label"
              :style="`width: ${item.width}px`"
            />
          </FormItem>
        </div>
        <Spin size="large" fix v-if="withdrawLoading" />
      </Form>
      <Button type="primary" @click="submitWithdraw" class="fiat-confirm-btn">CONFIRM</Button>
    </div>
    <div slot="footer" class="withdraw-modal-footer">
      <div class="withdraw-modal-footer-row">○ Min withdraw amount：50.00 {{(currentAsset.asset||'')}}</div>
      <div class="withdraw-modal-footer-row">○ Withdraw fee is 0.5%</div>
    </div>
  </div>
</template>
<script>
import axios from "@/service/interceptor";
import settings from "@/utils/settings";
import Balance from "@/utils/balance";
import RUC from "@/utils/Ruc";
import Utils from "@/utils/Utils";

export default {
  props: {
    currentAsset: Object
  },
  data() {
    return {
      withdrawForm: {},
      withdrawLoading: false,
      withdrawFeeConfig: {}
    };
  },
  async mounted() {
    this.getWithdrawAddress();
    const {
      data: {
        assets: { [this.currentAsset.id]: config = {} } = {},
        transferFeeToAccount
      } = {}
    } = await RUC.getDepositAddress(this.$store.getters.currAccount.userid);
    this.withdrawFeeConfig = { ...config, transferFeeToAccount };
    console.log({withdrawFeeConfig: this.withdrawFeeConfig, currentAsset: this.currentAsset})
  },
  methods: {
    async getWithdrawAddress() {
      this.withdrawLoading = true;
      try {
        const {
          data: { res }
        } = await axios.post(`${settings.HOST}/bittrade/v1`, {
          cmd: "fiatGetAddress",
          user_id: this.$store.getters.currAccount.userid
        });
        const address = res && res.pop();
        if (address) {
          this.withdrawForm = JSON.parse(address.data);
        }
      } catch (e) {
        console.warn("Error fetching past address");
      }
      this.withdrawLoading = false;
    },
    async submitWithdraw() {
      this.withdrawLoading = true;
      try {
        // validation
        const amount = Number(this.withdrawForm.withdraw_amount);
        const validation = await this.$refs.withdrawForm.validate();
        if (!validation) {
          throw new Error("Invalid Fields");
        }
        if (
          !amount ||
          amount < 0 ||
          amount > Number(this.currentAsset.available)
        ) {
          throw new Error("Invalid Amount");
        }
        // get password

        const password = await Utils.getPassword(this, {
          placeholder: "password"
        });
        if (!password) {
          throw new Error("Canceled");
        }
        // make transaction
        const transferParams = [
          this.$store.getters.currAccount,
          this.currentAsset,
          password,
          (this.$store.state.initData||{}).fiatAddress,
          amount,
          0,
          ""
        ];
        let transactionId;
        try {
          const { id} = await Balance.transferAction(
            ...transferParams
          );
          if(!id) throw new Error();
          transactionId = id;
        } catch (e) {
          throw new Error("Transaction Failed. Please check your password");
        }
        // add new address
        const {
          data: { id: addressId }
        } = await axios.post(`${settings.HOST}/bittrade/v1`, {
          cmd: "fiatAddAddress",
          user_id: this.$store.getters.currAccount.userid,
          data: JSON.stringify(this.withdrawForm)
        });
        // bind transaction with address
        const {
          data: { code }
        } = await axios.post(`${settings.HOST}/bittrade/v1`, {
          cmd: "fiatInsertTransactionAddress",
          user_id: this.$store.getters.currAccount.userid,
          address_id: addressId,
          trx_id: transactionId
        });
        if (code != 0) throw new Error(code);
        this.$Message.success("Withdrawal Successful");
        this.$emit("close");
      } catch (e) {
        this.$Message.error(e.message || "Request Failed");
      }
      this.withdrawLoading = false;
    }
  }
};
</script>
<style lang="less">
@import "../../../../static/style/color.less";
.dynamics-withdraw-modal {
  width: 920px;
  color: @font-black;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin: 20px 0;
  .withdraw-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    .ivu-form-item {
      margin: 5px 10px;
      .ivu-form-item-label {
        padding: 5px;
      }
    }
    .withdraw-section-header {
      line-height: 32px;
      height: 32px;
      color: #515a6e;
      background-color: #f9f9f9;
      text-align: center;
    }
    .ivu-collapse {
      border: none;
      .ivu-collapse-header {
        padding: 0;
        position: relative;
        height: 32px;
        .ivu-icon {
          position: absolute;
          left: 10px;
          top: 10px;
        }
      }
    }
  }
  .fiat-confirm-btn {
    border-radius: 20px;
    height: 40px;
    width: 370px;
    font-weight: bold;
    font-size: 16px;
    margin: 20px 0;
  }
  .withdraw-modal-footer {
    width: 100%;
    border-top: 1px solid #e8eaec;
    padding: 10px 20px;
    .withdraw-modal-footer-row {
      text-align: left;
      color: @light-grey-2;
      font-size: 12px;
      line-height: 16px;
      margin: 10px 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/channel-specific/dynamics/withdrawModal.vue